<!--
     <GenericAddButton
       :filters='QFilters'
       disabled
       @update="update_qunits(qunit)"
     />

     TODO:
     GenericAddButton no hauria de fer una petició cada explorer, demanant si es pot o no afegir. Hauriem de carregar la llista al fer login l'usuari, amb una petició com:
     → GET /business_process/bp_map
     ← {
       BP_CODE: {
         name: "My cute BP name",
         can_create: true,
       },
     }
     I guardar açò a l'state com a bpdb.

-->

<template>
  <div>
    <v-btn
      color="primary"
      small
      rounded
      class="add-button-fab explorer-header-component elevation-1"
      @click="loading || add_qunit()"
      :disabled="disabled || !can_create_units"
      :loading="loading"
      :icon="small"
      :outlined="small"
      :elevation="small ? 0 : 1"
    >
      <span v-if="!small">{{$vuetify.lang.translator('add')}}</span>
      <v-icon >mdi-plus</v-icon>
    </v-btn>

    <!-- Modal dialog -->
    <GenericQUnitTransition
      ref="genericTransition"
      :centro="filters.get_filter_value('centro')"
      :business_process="filters.get_filter_value('business_process')"
      @update="update_after_transition"
    />
  </div>
</template>


<style lang="scss">
 @import '@/sass/explorer.scss';
</style>


<script>
 import GenericQUnitTransition from '@/components/explorer/GenericQUnitTransition'
 import { mapState } from 'vuex';
 import { QFilters } from '@/qunit/filters';

 export default {
   name: 'GenericAddButton',

   components: {
     GenericQUnitTransition,
   },

   props: {
     filters: {type: QFilters ,required: true},
     disabled: {type: Boolean, default: false},
     small: {type: Boolean, default: false},
     is_mobile: {type: Boolean, default: false},
   },

   data: () => ({
     loading: false,
   }),

   computed: {
     ...mapState(['bpmap']),

     business_process() {
       return this.filters.get_filter_value('business_process');
     },


     can_create_units() {
       return !!(this.bpmap[this.business_process]||{}).can_create;
     },
   },

   methods: {
     async add_qunit() {
       this.loading = true;
       await this.$refs.genericTransition.add_qunit(this.business_process);
       this.loading = false;
     },

     update_after_transition(qunit) {
       this.$emit('update', qunit);
     },
   },
 }
</script>
